import styled from 'styled-components';
import { StyledSpaceSection } from '../../../SpaceSection/styled';

export const SimilarSpaceSection = styled(StyledSpaceSection)`
  padding-top: 0;
`;
